import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Table,
  Empty,
  message,
  Input,
  Tooltip,
  Modal,
  notification,
  Button,
  Form,
  Row,
  Col,
  Spin,
} from "antd";
import {
  RollbackOutlined,
  BarsOutlined,
  MailOutlined,
  MailFilled,
  TagsOutlined,
  DownloadOutlined,
  FilePdfOutlined,
  FileExcelOutlined,
  EditOutlined,
} from "@ant-design/icons";
import moment from "moment";
import config from "../../util/ApiforContext";
import ReactTags from "react-autocomplete-tag";
import { useMediaQuery } from "react-responsive";
import Screen from "../../util/Extensions/Screens";
import Iframe from "react-iframe";
import { ColumnHelper, RowHelper } from "util/TableHelper";
import RequestHandler from "util/RequestHandler";
import { odata } from "../Filters/Helper";
import AccountTransactionTableFilter from "../Filters/AccountTransactionTableFilter";

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 13,
  },
};

const AccountBank = (props) => {

  const isInitialMount = useRef(true);
  const { t } = useTranslation();
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
    values: {},
  });
  const [order, setOrder] = useState("");
  const [tableRole, setTableRole] = useState({});
  const [transactionId, setTransactionId] = useState("");
  const [drawerNoteUpdate, setDrawerNoteUpdate] = useState("");
  const [visibleNoteUpdate, setVisibleNoteUpdate] = useState(false);
  const [deleteModalVisibleMap, setDeleteModalVisibleMap] = useState({});

  const [loading, setLoading] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [EmailVisible, setEmailVisible] = useState(true);
  const [Email, setEmail] = useState(localStorage.getItem("email"));
  const [isModalVisibleReceipt, setIsModalVisible] = useState(false);
  const [accountIdForModalReceipt, setAccountIdForModalReceipt] = useState("");
  const [spinLoading, setSpinLoading] = useState(false);
  const [accountTransactionId, setAccountTransactionId] = useState();
  const [isTransactionTimeFilter, setTransactionTimeFilter] = useState([]);
  const [isHasDateFilter, setIsHasDateFilter] = useState(false);
  const [isLast7DaysFilterEnabled, setIsLast7DaysFilterEnabled] = useState(false);
  const [isLast1DayFilterEnabled, setIsLast1DayFilterEnabled] = useState(false);

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const [tags, setTags] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [prevTagList, setprevTagList] = useState([]);
  const [isModalTagVisible, setIsModalTagVisible] = useState(false);

  const history = useHistory();
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });

  useEffect(() => {
    RequestHandler.get(`/AccountTransaction/GetTransactionTableRole`).then(
      (response) => {
        if (response.success) {
          setTableRole(response.data);
        }
      }
    );

    RequestHandler.get(`/TenantTransactionTag/GetTransactionTagList`).then(
      (response) => {
        let tagList = [];
        response.map((item) => {
          tagList.push(item.tag);
        });
        setprevTagList(tagList);
      }
    );
    getTenantParameter();
  }, []);

  const getTenantParameter = () => {
    RequestHandler.get("/TenantParameter/GetByTenant").then((response) => {
      if (response) {

        if(!response.isHasDateFilter && !response.isLast1DayFilterEnabled && !response.isLast7DaysFilterEnabled) {
           isInitialMount.current = false;
           getTableData();
        }

        setTransactionTimeFilter(response.isTransactionTimeFilter);
        setIsHasDateFilter(response.isHasDateFilter);
        setIsLast1DayFilterEnabled(response.isLast1DayFilterEnabled);
        setIsLast7DaysFilterEnabled(response.isLast7DaysFilterEnabled);

        
      }
    });
  };

  useEffect(
    () => {
      if (!isInitialMount.current) {

        getTableData();
      }
    },
    [order, tableDataQueryOptions]);

  useEffect(() => {
      dateFilter();
  }, [isHasDateFilter, isLast1DayFilterEnabled, isLast7DaysFilterEnabled])

  const dateFilter = () => {
      let startDate;

      if(isLast1DayFilterEnabled) {
        startDate =  moment(new Date()).add(-1, "days");
      }
      else if(isLast7DaysFilterEnabled) {
        startDate =  moment(new Date()).add(-7, "days");
      }else if (isHasDateFilter)  {
        startDate = moment(new Date()).add(-1, "months")  
      }


      if(startDate) {
         setTableDataQueryOptions((prevState) => {
          return {
            ...prevState,
            skip: 0,
            current: 1,
            take: tableDataQueryOptions.take,
            values: {
              transactionDateMin: startDate,
              transactionDateMax: new Date()
            },
            filter: `${odata.dateRange("transactionDateValue", startDate,new Date())}`
          }});

               
        isInitialMount.current = false;
      }
  }

  const getFilterQuery = () => {
    const { filter } = tableDataQueryOptions;
    let _filter = filter;

    const conditions = ["isErpActivity eq false"];

    if (props.match.params.tenantAccountId) {
      conditions.push(
        `tenantAccountId eq ${props.match.params.tenantAccountId}`
      );
    }

    if (_filter) {
      conditions.push(_filter);
    }

    if (conditions.length !== 0) {
      return "$filter=" + conditions.join(" and ");
    }
    return "";
  };

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });
    const { skip, take } = tableDataQueryOptions;

    RequestHandler.get(
      `/AccountTransaction?$count=true&${getFilterQuery()}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      if (Array.isArray(response.value)) {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      }
    });
  };

  const paging = (p, filters, sorter) => {
    let order = "";
    if (sorter.columnKey && sorter.order) {
      order =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setOrder(order);
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    if(!isHasDateFilter && !isLast1DayFilterEnabled && !isLast7DaysFilterEnabled) {
        setTableDataQueryOptions({
        skip: 0,
        current: 1,
        take: tableDataQueryOptions.take,
        filter: "",
      });
    }
    else {
      dateFilter();
    }
  };

  const onFinishTableFilter = (query, values) => {
    if (values.dataRange != undefined || values.dataRange != null) {
      const [startDate, endDate] = values.dateRange;
      setStartDate(startDate);
      setEndDate(endDate);
    }

    setTableDataQueryOptions((prevState) => {
      return {
        skip: 0,
        current: 1,
        take: prevState.take,
        filter: query,
        values: values,
      };
    });
  };

  const onClickExportExcel = () => {
    const hideMessage = message.loading(t('excelDownloading'), 0);

    RequestHandler.post(
      `/AccountTransaction/ExportExcel`,
      {
        query: getFilterQuery(),
      },
      false
    ).then((res) => {
      if (res.success) {
        window.open(
          `${config.apiUrl}/AccountTransaction/DownloadExcel?fileName=${
            res.message
          }&t=${RequestHandler.getToken()}`
        );
      } else {
        notification.error({
          message: res.message,
          duration: 3,
        });
      }

      hideMessage();
    });
  };

  const onChangeEmail = (values) => {
    setEmail(values.target.value);
  };
  const addTag = (val) => {
    if (val.length > 1 && val.length < 21) {
      setTags([...tags, val]);
      setSuggestions([]);
    } else {
      countTagError("error");
    }
  };

  const countTagError = (type) => {
    notification[type]({
      message: t('error'),
      description: t('tagLengthError'),
      duration: 4,
    });
  };

  const handleOkTag = () => {
    RequestHandler.post(
      `/TenantTransactionTag`,
      {
        AccountTransactionId: accountTransactionId,
        tenantTransactionTags: tags,
      },
      true
    ).then((response) => {
      setIsModalTagVisible(false);
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    });
  };

  const handleCancelTag = () => {
    setIsModalTagVisible(false);
  };

  const showModalTag = (transactionId) => {
    setSpinLoading(true);
    setAccountTransactionId(transactionId);
    RequestHandler.get(
      `/TenantTransactionTag/GetListQueryableOdataWithAccountTransaction/${transactionId}`
    ).then((response) => {
      let tagList = [];
      response.map((item) => {
        tagList.push(item.transactionTagName);
      });
      setTags(tagList);
      setSpinLoading(false);
      setIsModalTagVisible(true);
    });
  };

  const removeTag = (idx) => {
    let t = [...tags];

    t.splice(idx, 1);

    setTags(t);
  };

  const handleTagChange = (val) => {
    if (val.length > 0) {
      let new_sug = [];
      prevTagList.forEach((t) => {
        if (t.includes(val)) {
          new_sug.push(t);
        }
      });
      setSuggestions(new_sug);
    } else {
      setSuggestions([]);
    }
  };

  const setDownloadPdf = () => {
    const hide = message.loading("Pdf indiriliyor...", 0);
    window.open(
      `${
        config.apiUrl
      }/Pdf/DownloadPdfReceiptColumnsWithDoc?id=${accountIdForModalReceipt}&isDownload=true&t=${RequestHandler.getToken()}`
    );
    setIsModalVisible(true);
    alertSuccess("success");
    hide();
  };

  const alertSuccess = (type) => {
    notification[type]({
      message: t('notificationSuccessTitle'),
      description: t('pdfDownloadSuccess'),
      duration: 2,
    });
  };

  const sendSuccessMail = (type) => {
    notification[type]({
      message: t('notificationSuccessTitle'),
      description: t('mailSendSuccess'),
      duration: 2,
    });
  };

  const showModalReceipt = (value) => {
    setAccountIdForModalReceipt(value);
    setEmailVisible(true);

    RequestHandler.get(
      `/Pdf/DownloadPdfReceiptColumnsWithDoc?id=${value}&isDownload=false&t=${RequestHandler.getToken()}`,
      undefined,
      { rawResponse: true }
    ).then((res) => {
      if (res.status == 200) {
        setPdfUrl(res.data);
      } else {
        setLoading(false);
      }
    });
    setIsModalVisible(true);
  };

  const mailEmptyError = (type) => {
    notification[type]({
      message: t('error'),
      description: t('emailAddressNotEntered'),
      duration: 2,
    });
  };

  const mailNotFound = (type) => {
    notification[type]({
      message: t('error'),
      description: t('emailAddressNotRegistered'),
      duration: 2,
    });
  };

  const handleOkReceipt = () => {
    setPdfUrl("");
    setIsModalVisible(false);
  };

  const handleCancelReceipt = () => {
    setPdfUrl("");

    setIsModalVisible(false);
  };

  const handleCancelNoteUpdate = (e) => {
    setVisibleNoteUpdate(false);
  };
  const onFinishFailedUpdate = (errorInfo) => {};
  const handleDeleteConfirm = () => {
    noteModalDelete(transactionId);
    setLoading(true);
    setDeleteModalVisibleMap((prevMap) => ({
      ...prevMap,
      [transactionId]: false,
    }));
  };
  const transactionNoteData = (record) => {
    RequestHandler.get(`/AccountTransaction/Getbyid/${record.id}`).then(
      (response) => {
        setTransactionId(response.id);
        setDrawerNoteUpdate(response.userNote);
        setVisibleNoteUpdate(true);
      }
    );
  };
  const onFinishNoteModal = (values) => {
    const { newNote } = values;
    RequestHandler.post(`/AccountTransaction/AccountTransactionUpdate`, {
      Id: transactionId,
      userNote: newNote,
    }).then((res) => {
      setLoading(false);
      setVisibleNoteUpdate(false);
      getTableData();
    });
  };
  const noteModalDelete = (id) => {
    RequestHandler.post(`/AccountTransaction/AccountTransactionUpdate`, {
      Id: id,
      userNote: null,
    }).then((res) => {
      setLoading(false);
      setVisibleNoteUpdate(false);
      getTableData();
    });
  };

  const sendMail = () => {
    setLoading(true);
    if (Email.length > 0) {
      RequestHandler.post(
        `/AccountTransaction/ReceiptSendMail`,
        { Email: Email, Path: pdfUrl, ScreenOption: Screen.screen },
        false,
        { rawResponse: true }
      ).then((res) => {
        if (res.data === "NotFound") {
          mailNotFound("error");
          setLoading(false);
        } else if (res.status == 204 || res.status == 200) {
          setLoading(false);
          setIsModalVisible(false);
          sendSuccessMail("success");
        }
      });
    } else {
      mailEmptyError("error");
      setLoading(false);
    }
  };
  const onClickCreatePdf = () => {
    const hideMessage = message.loading(t('pdfDownloading'), 0);
    RequestHandler.post(
      `/TenantAccount/CreatePdf`,
      { query: getFilterQuery() },
      false
    ).then((response) => {
      if (response === "Hesap hareketi bulunamadı.") {
        hideMessage();
        return;
      }
      hideMessage();
      window.open(
        config.apiUrl.replace("/api", "") +
          "/content/sourcepdf/AccountTransactionPdf/downloadpdfs/" +
          response,
        "_blank" // <- This is what makes it open in a new window.
      );
    });
  };
  const columns = [
    {
      title: t('bank'),
      dataIndex: "bankId",
      key: "bankId",
      render: (text, row, index) => {
        return (
          <div style={{ width: 84 }}>
            <img src={row.tenantBankLogo}></img>
          </div>
        );
      },
    },
    tableRole.isBranchShow === true
      ? {
          title: t('branch'),
          dataIndex: "tenantBranchCode",
          key: "tenantBranchCode",
          align: "center",
        }
      : {},
    tableRole.isAccountNameShow
      ? {
          title: t('accountName'),
          dataIndex: "tenantAccountName",
          key: "tenantAccountName",
        }
      : {},
    tableRole.isTenantIbanShow === true
      ? {
          title: t('ibanOrAccountNumber'),
          align: "center",
          dataIndex: "ibanOrAccountNumber",
          key: "ibanOrAccountNumber",
        }
      : {},
    {
      title: t('amount'),
      dataIndex: "amountString",
      key: "amountString",
      align: "center",
      render: (text) => {
        {
          return Screen.screenGercek === 2 || tableRole.isAmountColorful ? (
            <div
              style={{ width: 98, whiteSpace: "nowrap", textAlign: "right" }}
            >
              {text.includes("-") ? (
                <div style={{ color: "red" }}>{text}</div>
              ) : (
                <div style={{ color: "green", whiteSpace: "nowrap" }}>
                  {text}
                </div>
              )}
            </div>
          ) : (
            <div
              style={{ width: 98, whiteSpace: "nowrap", textAlign: "right" }}
            >
              {text}
            </div>
          );
        }
      },
    },
    tableRole.isBalanceAfterTransactionShow === true
      ? {
          title: t('balanceAfterTransaction'),
          align: "center",
          render: (row) => (
            <div style={{ textAlign: "right" }}>
              {ColumnHelper.renderDecimal(row.balanceAfterTransaction)}
            </div>
          ),
        }
      : {},
    tableRole.isCurrencyShow === true
      ? {
          title: t('currency'),
          dataIndex: "currency",
          align: "center",
          key: "currency",
          render: (text) => {
            {
              return <div>{text}</div>;
            }
          },
        }
      : {},
    {
      title: t('date'),
      dataIndex: "transactionDate",
      align: "center",
      width: "11%",
      sorter: true,
      key: "transactionDateValue",
      render: (text, row, index) => {
        {
          return <div> {row.transactionDate} </div>;
        }
      },
    },
    tableRole.isDescriptionShow === true
      ? {
          title: t('description'),
          align: "left",
          dataIndex: "description",
          key: "description",
          render: (text) => (
            <Tooltip placement="topLeft" title={text}>
              <div style={{ whiteSpace: "break-spaces" }}>
                {text?.substring(0, 60) === undefined
                  ? " "
                  : text?.trim().length <= 60
                  ? text + ""
                  : text?.substring(0, 125) + "..."}
              </div>
            </Tooltip>
          ),
        }
      : {},
    tableRole.isFirmNameShow
      ? {
          title: t('firmNameTitle'),
          dataIndex: "firmName",
          align: "center",
          key: "firmName",
          render: (text, row, index) =>
            text == null ? (
              <div style={{ opacity: 0.7 }}>-</div>
            ) : (
              <Tooltip placement="topLeft" title={text}>
                {text?.substring(0, 15) === undefined ? (
                  <div style={{ opacity: 0.7 }}>-</div>
                ) : text?.substring(0, 15).length < 8 ? (
                  text?.substring(0, 15) + ""
                ) : (
                  text?.substring(0, 8) + "..."
                )}
              </Tooltip>
            ),
        }
      : {},
    {
      title: t('tag'),
      dataIndex: "id",
      width: "1%",
      align: "center",
      render: (data) => {
        return (
          <a
            style={{ color: "black", fontSize: "130%" }}
            onClick={() => showModalTag(data)}
          >
            {" "}
            <TagsOutlined />
          </a>
        );
      },
    },
    {
      title: t('receipt'),
      dataIndex: "id",
      width: "1%",
      align: "center",
      render: (data) => {
        return (
          <a
            style={{ color: "black", fontSize: "130%" }}
            onClick={() => showModalReceipt(data)}
          >
            {" "}
            <FilePdfOutlined />
          </a>
        );
      },
    },
    tableRole.isNoteShow === true
      ? {
          title: t('addOrDeleteNote'),
          dataIndex: "operation",
          align: "center",
          width: "1%",
          render: (text, record) => {
            return (
              <a
                onClick={() => {
                  transactionNoteData(record);
                }}
                style={{ color: "orange", fontSize: "130%" }}
              >
                <EditOutlined />
              </a>
            );
          },
        }
      : {},
  ];

  const detailColumns = [
    tableRole.isIbanShow
      ? {
          title: t('counterIban'),
          dataIndex: "iban",
        }
      : {},
    tableRole.isVknTcknShow
      ? {
          title: t('vknOrTckn'),
          dataIndex: "vkn",
          render: (data, row, index) => data ?? row.tckn,
        }
      : {},
    tableRole.isTransactionTypeShow
      ? {
          title: t('transactionType'),
          dataIndex: "transactionTypeName",
        }
      : {},
    tableRole.isSenderNameShow
      ? {
          title: t('senderName'),
          dataIndex: "senderName",
        }
      : {},
    tableRole.isReceiptShow
      ? {
          title: t('receiptNumber'),
          dataIndex: "receiptNumber",
        }
      : {},
    tableRole.isDescriptionShow
      ? {
          title: t('bankDescription'),
          dataIndex: "description",
        }
      : {},
    tableRole.isAdditionalDescriptionShow
      ? {
          title: t('additionalDescription'),
          dataIndex: "additionalDescription",
        }
      : {},
    tableRole.isNoteShow === true
      ? {
          title: t('note'),
          dataIndex: "userNote",
        }
      : { title: "" },
  ];

  return (
    <>
      {props.match.params.tenantAccountId && (
        <Row style={{ marginBottom: 9 }}>
          <Col flex={1}>
            <a
              onClick={() => history.goBack()}
              style={{ color: "black", marginLeft: "4%" }}
            >
              {" "}
              <RollbackOutlined /> {t('goBack')}
            </a>
          </Col>
          <Col flex={4}></Col>
        </Row>
      )}

      <Row>
        <Col xs={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> {t('bankAccountTransactionPageTitle')}
          </p>
        </Col>
        <Col xs={8}>
          <Row justify="end" align="middle" style={{ paddingRight: 16 }}>
            <Tooltip title={t('downloadPdf')}>
              <a
                style={{
                  color: "red",
                  fontSize: "180%",
                  marginRight: 30,
                }}
                onClick={onClickCreatePdf}
              >
                <FilePdfOutlined />
              </a>
            </Tooltip>
            <Tooltip title={t('downloadExcel')}>
              <a
                style={{
                  color: "green",
                  fontSize: "180%",
                  marginRight: 30,
                }}
                onClick={onClickExportExcel}
              >
                <FileExcelOutlined />
              </a>
            </Tooltip>
          </Row>
        </Col>
      </Row>

      <AccountTransactionTableFilter
        isTransactionTimeFilter={isTransactionTimeFilter}
        data={tableDataQueryOptions.values}
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        hideBankIdFilter={true}
        hideTenantAccountNameFilter={true}
        hideTenantAccountNumberFilter={true}
        hideCurrencyIdFilter={true}
        style={{ marginTop: 12, marginBottom: 12 }}
        extraText={isHasDateFilter ? "Varsayılan olarak son 1 aylık veri listelenmektedir." : isLast1DayFilterEnabled ? "Varsayılan olarak son 1 günlük veri listelenmektedir.": isLast7DaysFilterEnabled ? "Varsayılan olarak son 7 günlük veri listelenmektedir." : ""}
      />

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            expandable={{
              expandedRowRender: (row) =>
                RowHelper.renderRowDetail({
                  data: row,
                  columns: detailColumns,
                }),
            }}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={t('noData')}
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>

      <Modal
        title={t('editNote')}
        visible={visibleNoteUpdate}
        onCancel={handleCancelNoteUpdate}
        closable={true}
        footer={null}
        destroyOnClose={false}
      >
        <div style={{ marginBottom: "-40px" }}>
          <Row justify="end">
            <Form
              name="basic"
              style={{ width: "100%" }}
              onFinish={onFinishNoteModal}
              onFinishFailed={onFinishFailedUpdate}
              fields={[{ name: "newNote", value: drawerNoteUpdate }]}
            >
              <Form.Item name="newNote">
                <Input.TextArea
                  placeholder={t('writeYourNoteHere')}
                  autoSize={{ minRows: 6, maxRows: 6 }}
                  value={drawerNoteUpdate}
                  onChange={(e) => setDrawerNoteUpdate(e.target.value)}
                />
              </Form.Item>
              <Col
                span={24}
                style={{
                  textAlign: "right",
                }}
              >
                <Form.Item>
                  <Button
                    type="warning"
                    htmlType="button"
                    onClick={() => handleDeleteConfirm()}
                    loading={loading}
                  >
                    {t('delete')}
                  </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    onClick={() => setLoading(true)}
                    loading={loading}
                  >
                    {t('update')}
                  </Button>
                </Form.Item>
              </Col>
            </Form>
          </Row>
        </div>
      </Modal>

      <Modal
        title={t('tag')}
        width={600}
        style={{ height: 1000 }}
        visible={isModalTagVisible}
        onOk={handleOkTag}
        onCancel={handleCancelTag}
        okText={t('save')}
      >
                  <Spin spinning={spinLoading} tip={t('loading')}>
          <ReactTags
            tags={tags}
            suggestions={suggestions}
            placeholder={t('enterTag')}
            onAddHandler={(val) => addTag(val)}
            onDeleteHandler={(idx) => removeTag(idx)}
            onChangeHandler={(val) => handleTagChange(val)}
          />
        </Spin>
      </Modal>

      {isDesktopOrLaptop ? (
        <Modal
          title={t('receipt')}
          width={1000}
          style={{ height: 1000 }}
          visible={isModalVisibleReceipt}
          onOk={handleOkReceipt}
          onCancel={handleCancelReceipt}
          footer={null}
        >
          <Form
            {...layout}
            name="basic"
            initialValues={{
              remember: true,
            }}
            fields={[{ name: "Email", value: Email }]}
          >
            <Row>
              <Col span={20}></Col>
              <Col span={2}>
                {EmailVisible ? (
                  <MailOutlined
                    style={{ fontSize: 20, marginBottom: 20 }}
                    onClick={() => setEmailVisible(!EmailVisible)}
                  />
                ) : (
                  <MailFilled
                    style={{ fontSize: 20, marginBottom: 20 }}
                    onClick={() => setEmailVisible(!EmailVisible)}
                  />
                )}
              </Col>
              <Col span={2}>
                <DownloadOutlined
                  style={{ fontSize: 20, marginBottom: 20 }}
                  onClick={() => setDownloadPdf()}
                />
              </Col>
            </Row>
            <Row hidden={EmailVisible}>
              <Col span={18}>
                <Form.Item
                  label={t('emailAddress')}
                  name="Email"
                  style={{ width: "100%" }}
                >
                  <Input value={Email} onChange={onChangeEmail} />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item>
                  <Button
                    type="primary"
                    onClick={() => sendMail()}
                    loading={loading}
                  >
                    {t('send')}
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Iframe
            url={pdfUrl}
            width="100%"
            height="1000px"
            id="myId"
            className="myClassname"
            display="initial"
            position="relative"
          />
        </Modal>
      ) : (
        <Modal
          title={t('receipt')}
          visible={isModalVisibleReceipt}
          onOk={handleOkReceipt}
          onCancel={handleCancelReceipt}
          footer={null}
        >
          <Form
            {...layout}
            name="basic"
            initialValues={{
              remember: true,
            }}
            fields={[{ name: "Email", value: Email }]}
          >
            <Row>
              <Col span={14}></Col>
              <Col span={5}>
                {EmailVisible ? (
                  <MailOutlined
                    style={{ fontSize: 20, marginBottom: 20 }}
                    onClick={() => setEmailVisible(!EmailVisible)}
                  />
                ) : (
                  <MailFilled
                    style={{ fontSize: 20, marginBottom: 20 }}
                    onClick={() => setEmailVisible(!EmailVisible)}
                  />
                )}
              </Col>
              <Col span={5}>
                <DownloadOutlined
                  style={{ fontSize: 20, marginBottom: 20 }}
                  onClick={() => setDownloadPdf()}
                />
              </Col>
            </Row>
            <Row hidden={EmailVisible}>
              <Col span={12}>
                <Form.Item label="" name="Email" style={{ width: "140%" }}>
                  <Input value={Email} onChange={onChangeEmail} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item>
                  <Button
                    type="primary"
                    onClick={() => sendMail()}
                    loading={loading}
                  >
                    {t('send')}
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Iframe
            url={pdfUrl}
            width="100%"
            height="400px"
            id="myId"
            className="myClassname"
            display="initial"
            position="relative"
          />
        </Modal>
      )}
    </>
  );
};

export default AccountBank;
